/**
 * Firebase Connections
 */

// Dependencies
import path from 'path'
import Firebase from 'firebase'
import config from '@/../config/app.json'

// Init Firebase
Firebase.initializeApp(config.firebase)

// Functions
const prepIn = (data, timestamp = true) => {
	if( timestamp ) {
		if( !data.createdAt ) {
			data.createdAt = Firebase.database.ServerValue.TIMESTAMP
		} else {
			data.updatedAt = Firebase.database.ServerValue.TIMESTAMP
		}
	}

	let res = {}
	for( let key in data ) {
		if( key.indexOf('$') !== 0 && key.indexOf('.key') !== 0 ) {
			if( data[key] && typeof data[key] === 'object' ) {
				res[key] = prepIn(data[key],false)
			} else {
				res[key] = data[key]
			}
		}
	}

	if( data['$priority'] || data['.priority'] ) {
		res['.priority'] = data['$priority'] || data['.priority']
	}

	return res
}

/**
 * Format firebase data for output.
 * @param  {object} data Raw firebase format data
 * @return {object}
 */
const prepOut = (data,isArray) => {
	if( isArray ) {
		let res = []
		data.forEach( snap => {
			res.push( _buildObject(snap) )
		})
		return res
	} else {
		return _buildObject(data)
	}
}

/**
 * Build Firebase object with relevant firebase data for better references.
 * @param  {object} snap Firebase snapshot
 * @return {object}      Formatted object
 */
const _buildObject = snap => {
	let res = {}

	let val = snap.val()
	let ref = snap.ref.toString().replace(config.firebase.databaseURL,'')
	let key = snap.key
	let priority = snap.getPriority()
	let length = snap.numChildren()

	return Object.assign({}, val, {
		'$key': key,
		'$id': key,
		'$ref': ref,
		'$priority': priority,
		'$length': length
	})
}


// Refs
class Refs {

	constructor (siteId)
	{
		if( siteId ) {
			this.settings = path.join('settings',siteId)
			this.notifications = path.join('notifications',siteId)
			this.queue = path.join('queue',siteId)
		}
	}
}

export default {
	auth: Firebase.auth,
	database: Firebase.database,
	refs: Refs,
	prepIn: prepIn,
	prepOut: prepOut
}


// WEBPACK FOOTER //
// ./src/lib/fb/index.js